import Button from "../Button/Button";
import Dropdown from "../Dropdown/Dropdown";
import { IconComponentType } from "../Icon/Icon";
import styles from "./TableToolbar.module.scss";

type TableToolbarButton = {
  label: string;
  IconComponent: IconComponentType;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
};

type TableToolbarDropdown = {
  label: string;
  items: TableToolbarButton[];
};

type TableToolbarItem = TableToolbarButton | TableToolbarDropdown;

function TableToolbar({ items }: { items: TableToolbarItem[] }) {
  return items.map((item) => {
    if ("items" in item) {
      return (
        <Dropdown
          withinPortal
          key={item.label}
          size="xsmall"
          variant="unstyled"
          classNames={{
            button: styles.button,
            menu: styles.menu,
          }}
          flat
          items={[{ items: item.items }]}
        >
          {item.label}
        </Dropdown>
      );
    }

    return (
      <Button
        key={item.label}
        leftIcon={<item.IconComponent />}
        onClick={item.onClick}
        className={styles.button}
        variant="unstyled"
        flat
        size="xsmall"
        disabled={item.disabled}
      >
        {item.label}
      </Button>
    );
  });
}

export default TableToolbar;
